import { render, staticRenderFns } from "./GradeCategorySuggestions.vue?vue&type=template&id=5105c0e2"
import script from "./GradeCategorySuggestions.vue?vue&type=script&lang=js"
export * from "./GradeCategorySuggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports